let button = document.getElementById("showFuneralPopup");
let div = document.getElementById("funeralPopup");
let overlay = document.getElementById("funeralPopupOverlay");
let form1 = document.getElementById("funeralForm1");
let form2 = document.getElementById("funeralForm2");
let form3 = document.getElementById("funeralForm3");

// Show the div when the button is clicked
button.addEventListener("click", function(event) {
    overlay.style.display = "flex";
    div.style.display = "flex";
    event.stopPropagation(); // Prevent click from reaching document
});

overlay.addEventListener("click", function(event) {
    overlay.style.display = "none";
    form1.style.display = "none";
    form2.style.display = "none";
    form3.style.display = "none";
    event.stopPropagation(); // Prevent click from reaching document
});

// Hide the div when clicking outside of it
document.addEventListener("click", function(event) {
    if (event.target !== div && event.target !== button) {
        div.style.display = "none";
        form1.style.display = "none";
        form2.style.display = "none";
        form3.style.display = "none";
    }
});

// Prevent div from closing when clicking inside it
div.addEventListener("click", function(event) {
    event.stopPropagation();
});
form1.addEventListener("click", function(event) {
    event.stopPropagation();
});
form2.addEventListener("click", function(event) {
    event.stopPropagation();
});
form3.addEventListener("click", function(event) {
    event.stopPropagation();
});

document.getElementById("showForm1").addEventListener("click", function(event) {
    event.preventDefault();
    document.getElementById("funeralForm1").style.display = "flex";
    document.getElementById("funeralPopup").style.display = "none";
});

document.getElementById("showForm2").addEventListener("click", function(event) {
    event.preventDefault();
    document.getElementById("funeralForm2").style.display = "flex";
    document.getElementById("funeralPopup").style.display = "none";
});

document.getElementById("showForm3").addEventListener("click", function(event) {
    event.preventDefault();
    document.getElementById("funeralForm3").style.display = "flex";
    document.getElementById("funeralPopup").style.display = "none";
});